'use strict';

import { Entity } from '../Entity';
import { Ind } from '../Ind/Ind';
import { UserEmailBatch } from './UserEmailBatch';

export class UserEmailBatchQueue extends Entity {
  protected queueId;
  protected emailAddress;
  protected emailBody;
  protected emailStatus;
  protected queueDate;
  protected emailQueueStatus;
  protected emailSentDate;

  protected batch;
  protected individual;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.queueId = data.queueId;
    this.emailAddress = data.emailAddress;
    this.emailBody = data.emailBody;
    this.emailStatus = data.emailStatus;
    this.emailQueueStatus = data.emailQueueStatus;
    this.emailSentDate = data.emailSentDate;

    if (data.queueDate) {
      const queueDate = data.queueDate.date.split(' ')[0].split('-');
      this.queueDate = queueDate[1] + '/' + queueDate[2] + '/' + queueDate[0];
    }

    if (data.emailSentDate) {
      const emailSentDate = data.emailSentDate.date.split(' ')[0].split('-');
      this.emailSentDate = emailSentDate[1] + '/' + emailSentDate[2] + '/' + emailSentDate[0];
    }

    if (data.batch) {
      const batch = new UserEmailBatch();
      batch.hydrate(data.batch);

      this.batch = batch;
    }

    if (data.individual) {
      const individual = new Ind();
      individual.hydrate(data.individual);

      this.individual = individual;
    }
  }

  public getQueueId() {
    return this.queueId;
  }

  public getEmailAddress() {
    return this.emailAddress;
  }

  public getEmailBody() {
    return this.emailBody;
  }

  public getQueueDate() {
    return this.queueDate;
  }

  public getEmailStatus() {
    return this.emailStatus;
  }

  public getEmailQueueStatus() {
    return this.emailQueueStatus;
  }

  public getEmailSentDate() {
    return this.emailSentDate;
  }

  public getInd() {
    return this.individual;
  }

  public getBatch() {
    return this.batch;
  }
}
